

























































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";

import ListMailAddresses from "../general/ListMailAddresses.vue";

import HolidaysBookingDetails from "./HolidaysBookingDetails.vue";
import HolidaysParticipantsPrintList from "./HolidaysParticipantsPrintList.vue";
import HolidaysParticipantsPrintListShort from "./HolidaysParticipantsPrintListShort.vue";
import HolidaysParticipantsPrintListByGroup from "./HolidaysParticipantsPrintListByGroup.vue";
import HolidaysBookingsPrintSticker from "./HolidaysBookingsPrintSticker.vue";
import HolidayProgramJson from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson from "../../shared/HolidayProgramBookingJson";
import HolidayProgramWithBookingsJson from "../../shared/HolidayProgramJson";
import HolidayProgramWithBookingJson from "../../shared/HolidayProgramJson";

import CustomerJson from "../../shared/CustomerJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "HolidaysParticipants",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    ListMailAddresses,
    HolidaysBookingDetails,
    HolidaysParticipantsPrintList,
    HolidaysParticipantsPrintListShort,
    HolidaysParticipantsPrintListByGroup,
    HolidaysBookingsPrintSticker,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    HolidayProgramBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      showDetails: false,
      showMailAddressesList: false,
      bookedMailAddressesList: [] as string[],
      showPrintSticker: false,
      printStickerBackImageUrl: "",
      detailsMode: "read",
      searchStringBooked: "",
      allHolidayPrograms: null as HolidayProgramJson[] | null,
      selectedHolidayProgramBookings: null as HolidayProgramBookingJson[] | null,
      selectedHolidayProgramId: null as number | null,
      selectedHolidayBookingId: null as number | null,
      showOldPrograms: false as boolean,
      showByChilds: false,
      isExporting: false,
      loadingConfirmation: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: HolidayProgramWithBookingJson | null, mode: string) {
      if (this.selectedHolidayProgramId != null) {
        if (item != null) {
          this.selectedHolidayBookingId = item.ID;
        } else {
          this.selectedHolidayBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllHolidayPrograms();
    },

    async loadAllHolidayPrograms() {
      this.allHolidayPrograms = null;
      this.selectedHolidayProgramId = null;
      this.selectedHolidayBookingId = null;
      this.selectedHolidayProgramBookings = null;

      if (this.restClient != null) {
        try {
          this.allHolidayPrograms = await this.restClient.getHolidayPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedHolidayProgramBookings() {
      if (this.allHolidayPrograms != null) {
        this.selectedHolidayProgramBookings = null;

        if (this.restClient != null && this.selectedHolidayProgramId != null) {
          try {
            let holidayProgramWithBookings = await this.restClient.getHolidayProgramWithBookings(
              this.selectedHolidayProgramId
            );
            this.selectedHolidayProgramBookings = holidayProgramWithBookings.bookings;
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async reloadData() {
      this.loadSelectedHolidayProgramBookings();
    },

    async sendBookingConfirmation(bookingDetails: HolidayProgramBookingJson) {
      if (this.selectedHolidayProgramId != null && bookingDetails != null && this.restClient != null) {
        this.loadingConfirmation = true;

        try {
          await this.restClient.confirmHolidayProgramBooking(this.selectedHolidayProgramId, bookingDetails);
          alert("Die Anfrage wurde gebucht und es wurde eine Bestätigung an den Kunden gesendet.");
          this.loadingConfirmation = false;
          this.reloadData();
        } catch (e) {
          this.loadingConfirmation = false;
          alert(e.message);
        }
      }
    },

    sendMailToBooked() {
      if (this.bookedHolidayBookings != null) {
        this.bookedMailAddressesList = [];
        var mailtoString = "mailto:" + GeneralInfos.email;

        mailtoString += "?bcc=";

        for (let i = 0; i < this.bookedHolidayBookings.length; i++) {
          let mailAddress = this.bookedHolidayBookings[i].customers[0].email;

          if (!this.bookedMailAddressesList.includes(mailAddress)) {
            this.bookedMailAddressesList.push(mailAddress);
          }
        }

        mailtoString += this.bookedMailAddressesList.join(";");

        if (mailtoString.length < 2048) {
          window.location.href = mailtoString;
          //window.open(mailtoString, "_blank")
        } else {
          alert(
            "Die E-Mail Vorlage an alle Teilnehmenden konnte leider nicht automatisch erstellt werden. Im folgenden werden die E-Mail Adressen zum kopieren angezeigt."
          );
          this.showMailAddressesList = true;
        }
      }
    },

    //print list
    printSelectedHolidayProgramBookingsList(mode: "default" | "short" | "grouped" = "default") {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        if (mode == "short") {
          var eles = this.$el.querySelectorAll(".print-view-short");
        } else if (mode == "grouped") {
          var eles = this.$el.querySelectorAll(".print-view-grouped");
        } else {
          var eles = this.$el.querySelectorAll(".print-view");
        }

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    //print sticker
    startPrintSticker(url: string) {
      this.showPrintSticker = false;

      this.printStickerBackImageUrl = url;
      this.$nextTick(() => {
        this.printSelectedHolidayProgramBookingsSticker();
      });
    },

    printSelectedHolidayProgramBookingsSticker() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view-sticker");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    //export all bookings list
    async downloadBookingsList(sortedByChilds: boolean) {
      if (this.selectedHolidayProgramId != null) {
        this.isExporting = true;

        try {
          var data = await this.restClient.downloadHolidayProgramBookingsListFile(
            this.selectedHolidayProgramId,
            sortedByChilds
          );
          if (data != null) {
            let atag = document.createElement("a");
            atag.style.display = "none";
            document.body.appendChild(atag);

            let blob = new Blob([data], { type: "octet/stream" });
            let url = window.URL.createObjectURL(blob);

            atag.href = url;
            //todo: besserer Dateiname
            atag.download = "ferien-buchungen.csv";
            atag.click();
            window.URL.revokeObjectURL(url);

            this.isExporting = false;
          }
        } catch (e) {
          this.isExporting = false;
          alert(e.message);
        }
      }
    },

    //export subsudy list
    async downloadSubsidyList() {
      if (this.selectedHolidayProgramId != null) {
        this.isExporting = true;

        try {
          var data = await this.restClient.downloadHolidayProgramSubsidyListFile(this.selectedHolidayProgramId);
          if (data != null) {
            let atag = document.createElement("a");
            atag.style.display = "none";
            document.body.appendChild(atag);

            let blob = new Blob([data], { type: "octet/stream" });
            let url = window.URL.createObjectURL(blob);

            atag.href = url;
            //todo: besserer Dateiname
            atag.download = "ferienbetreuung.zip";
            atag.click();
            window.URL.revokeObjectURL(url);

            this.isExporting = false;
          }
        } catch (e) {
          this.isExporting = false;
          alert(e.message);
        }
      }
    },

    checkSelectedExtraEarlyCare(item: HolidayProgramBookingJson) {
      var earlyCare = item.selectedExtras.find((i) => i == "Frühbetreuung");

      if (earlyCare !== undefined) {
        return true;
      } else {
        return false;
      }
    },

    getAllChildNames(customers: CustomerJson[]) {
      var childs = "";

      for (let i = 0; i < customers.length; i++) {
        if (i != 0) {
          childs += ", ";
        }
        childs += customers[i].childFirstName;
        childs += " ";
        childs += customers[i].childLastName;
      }

      return childs;
    },

    getWorking(item: HolidayProgramBookingJson) {
      let string = "";

      string += item.isWorking ? "Ja" : "Nein";
      string += " | ";
      string += item.isPartnerWorking ? "Ja" : "Nein";

      return string;
    },

    getAllHolidayProgramDates(holidayProgram: HolidayProgramJson) {
      var dates = [];

      var current = new Date(holidayProgram.beginDate);

      while (current <= new Date(holidayProgram.endDate)) {
        dates.push(DateFormatter.formatISODate(current));
        current.setDate(current.getDate() + 1);
      }

      return dates;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "sendBookingConfirmation") {
        this.sendBookingConfirmation(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredHolidayPrograms(): HolidayProgramJson[] | null {
      if (this.allHolidayPrograms != null && !this.showOldPrograms) {
        let today = new Date();
        let filtered = this.allHolidayPrograms.filter((i: any) => new Date(i.endDate) > today);

        return filtered;
      } else {
        return this.allHolidayPrograms;
      }
    },

    holidayColumns: function (): TableViewColumnDefinitions<HolidayProgramBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Erziehungsberechtigte:r",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Anzahl Kinder",
          td: (i) => i.customers.length + "",
        },
        {
          th: "Kinder",
          td: (i) => (i.customers.length > 0 ? vue.getAllChildNames(i.customers) : "--"),
        },
        {
          th: "Preiskategorie",
          td: (i) =>
            (i.selectedDiscount ? i.selectedDiscount : "Normalpreis") +
            " (€ " +
            (i.price ? vue.getFormatPrice(i.price!) : "-,--") +
            ")",
        },
        {
          th: "Alleinerziehend",
          td: (i) => (i.isSingleParent == null ? "Keine Angabe" : i.isSingleParent ? "Ja" : "Nein"),
        },
        {
          th: "Berufstätig | Partner Berufstätig",
          td: (i) => vue.getWorking(i),
        },
        {
          th: "Status",
          td: (i) => vue.HolidayProgramBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<HolidayProgramBookingJson>[];
    },

    holidayColumnsByChilds: function (): TableViewColumnDefinitions<HolidayProgramBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Kind",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].childLastName + ", " + i.customers[0].childFirstName : "--",
        },
        {
          th: "Erziehungsberechtigte:r",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Preiskategorie",
          td: (i) =>
            (i.selectedDiscount ? i.selectedDiscount : "Normalpreis") +
            " (€ " +
            (i.price ? vue.getFormatPrice(i.price!) : "-,--") +
            ")",
        },
        {
          th: "Alleinerziehend",
          td: (i) => (i.isSingleParent == null ? "Keine Angabe" : i.isSingleParent ? "Ja" : "Nein"),
        },
        {
          th: "Berufstätig | Partner Berufstätig",
          td: (i) => vue.getWorking(i),
        },
        {
          th: "Gruppe",
          td: (i) => (i.customers[0].holidayBookingGroup != "" ? i.customers[0].holidayBookingGroup : "--"),
        },
        {
          th: "Status",
          td: (i) => vue.HolidayProgramBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<HolidayProgramBookingJson>[];
    },

    holidayWaitinglistColumns: function (): TableViewColumnDefinitions<HolidayProgramBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Erziehungsberechtigte:r",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Anzahl Kinder",
          td: (i) => i.customers.length + "",
        },
        {
          th: "Kinder",
          td: (i) => (i.customers.length > 0 ? vue.getAllChildNames(i.customers) : "--"),
        },
        {
          th: "Preiskategorie",
          td: (i) =>
            (i.selectedDiscount ? i.selectedDiscount : "Normalpreis") +
            " (€ " +
            (i.price ? vue.getFormatPrice(i.price!) : "-,--") +
            ")",
        },
        {
          th: "Alleinerziehend",
          td: (i) => (i.isSingleParent == null ? "Keine Angabe" : i.isSingleParent ? "Ja" : "Nein"),
        },
        {
          th: "Berufstätig | Partner Berufstätig",
          td: (i) => vue.getWorking(i),
        },
        {
          th: "Status",
          td: (i) => vue.HolidayProgramBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Aufrücken und benachrichtigen",
          style: (i) => "text-align:right",
          button: "sendBookingConfirmation",
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<HolidayProgramBookingJson>[];
    },

    hasHolidayProgramAddonPriceEarlyCare() {
      if (this.selectedHolidayProgramInfo) {
        if (this.selectedHolidayProgramInfo.addonPrices.find((i) => i.title === "Frühbetreuung")) {
          return true;
        } else {
          return false;
        }
      }
    },

    selectedHolidayProgramInfo(): HolidayProgramJson | undefined {
      if (this.allHolidayPrograms != null) {
        var selectedInfo = this.allHolidayPrograms.find((i) => i.ID == this.selectedHolidayProgramId);

        return selectedInfo;
      }

      return undefined;
    },

    holidayProgramRegistrationsLeftText(): string {
      if (
        this.allHolidayPrograms != null &&
        this.selectedHolidayProgramId != null &&
        this.selectedHolidayProgramBookings != null
      ) {
        let maxRegistrationCount = this.allHolidayPrograms.find(
          (i) => i.ID == this.selectedHolidayProgramId
        )?.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.selectedHolidayProgramBookings.length; i++) {
          if (
            this.selectedHolidayProgramBookings[i].state != "pending" &&
            this.selectedHolidayProgramBookings[i].state != "canceled" &&
            this.selectedHolidayProgramBookings[i].state != "cancellationFeeExported" &&
            this.selectedHolidayProgramBookings[i].state != "waitingList"
          ) {
            registrationCount += this.selectedHolidayProgramBookings[i].customers.length;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    holidayProgramWaitingListLeftText(): string {
      if (
        this.allHolidayPrograms != null &&
        this.selectedHolidayProgramId != null &&
        this.selectedHolidayProgramBookings != null
      ) {
        const maxWaitingListCount = this.allHolidayPrograms.find(
          (i) => i.ID == this.selectedHolidayProgramId
        )?.waitingListMaximumCount;
        let waitingListCount = 0;

        for (let i = 0; i < this.selectedHolidayProgramBookings.length; i++) {
          if (this.selectedHolidayProgramBookings[i].state == "waitingList") {
            waitingListCount += this.selectedHolidayProgramBookings[i].customers.length;
          }
        }

        if (maxWaitingListCount === undefined) {
          return "Warteliste: [Fehler]";
        }

        let waitingListLeft = maxWaitingListCount - waitingListCount;

        if (waitingListLeft < 0) {
          return "Warteliste: Überbucht";
        } else if (waitingListLeft == 1) {
          return "Warteliste: 1 Platz frei";
        } else {
          return "Warteliste: " + waitingListLeft + " Plätze frei";
        }
      }

      return "Lade Warteliste...";
    },

    requestedHolidayBookings(): HolidayProgramBookingJson[] | null | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var states = ["pending"];
        let requestedHolidayBookings = this.selectedHolidayProgramBookings.filter((i) => states.includes(i.state));
        return requestedHolidayBookings;
      }
    },

    bookedHolidayBookings(): HolidayProgramBookingJson[] | null | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var states = ["booked", "readyForPayment", "paymentExported"];
        let bookedHolidayBookings = this.selectedHolidayProgramBookings.filter((i) => states.includes(i.state));
        return bookedHolidayBookings;
      }
    },

    bookedHolidayBookingsCount(): number {
      let registrationCount = 0;

      if (this.bookedHolidayBookings) {
        for (let i = 0; i < this.bookedHolidayBookings.length; i++) {
          registrationCount += this.bookedHolidayBookings[i].customers.length;
        }
      }

      return registrationCount;
    },

    filteredBookedHolidayBookings(): HolidayProgramBookingJson[] {
      var bookings: HolidayProgramBookingJson[] = [];

      if (this.bookedHolidayBookings) {
        bookings = this.bookedHolidayBookings;

        var tokens = this.searchStringBooked
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          bookings = bookings.filter((i) => {
            if (
              (i.customers.length > 0 && i.customers[0].guardianFirstName.toLowerCase().includes(token)) ||
              i.customers[0].guardianLastName.toLowerCase().includes(token) ||
              this.getAllChildNames(i.customers).toLowerCase().includes(token)
            ) {
              return true;
            }

            if (i.invoiceInfos && i.invoiceInfos.find((j) => j.invoiceNumber.toLowerCase().includes(token))) {
              return true;
            }

            return false;
          });
        }

        if (this.showByChilds) {
          var bookingsByCustomer = [];

          for (let booking of bookings) {
            for (let i = 0; i < booking.customers.length; i++) {
              let bookingOneChild = { ...booking };
              bookingOneChild.customers = [];
              bookingOneChild.customers.push(booking.customers[i]);
              bookingsByCustomer.push(bookingOneChild);
            }
          }

          return bookingsByCustomer;
        }
      }

      return bookings;
    },

    waitingListHolidayBookings(): HolidayProgramBookingJson[] | null | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var states = ["waitingList"];
        let waitingListHolidayBookings = this.selectedHolidayProgramBookings.filter((i) => states.includes(i.state));
        return waitingListHolidayBookings;
      }
    },

    sortedBookedHolidayBookingsByGuardianLastName(): HolidayProgramBookingJson[] | null | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var states = ["booked", "readyForPayment", "paymentExported"];
        let bookedHolidayBookings = this.selectedHolidayProgramBookings.filter((i) => states.includes(i.state));

        bookedHolidayBookings.sort(function (a, b) {
          let nameA = a.customers[0].guardianLastName.toLowerCase();
          let nameB = b.customers[0].guardianLastName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return bookedHolidayBookings;
      }
    },

    sortedBookedHolidayBookingsByChildLastName(): object[] | null | undefined {
      if (this.selectedHolidayProgramBookings != null) {
        var states = ["booked", "readyForPayment", "paymentExported"];
        let bookedHolidayBookings = this.selectedHolidayProgramBookings.filter((i) => states.includes(i.state));

        var customers = [];

        for (let i = 0; i < bookedHolidayBookings.length; i++) {
          for (let j = 0; j < bookedHolidayBookings[i].customers.length; j++) {
            var newObj: any = {};

            let k = bookedHolidayBookings[i].customers[j];
            let index: keyof typeof k;

            for (index in bookedHolidayBookings[i].customers[j]) {
              newObj[index] = bookedHolidayBookings[i].customers[j][index];
            }

            if (this.checkSelectedExtraEarlyCare(bookedHolidayBookings[i])) {
              newObj["earlyCare"] = true;
            } else {
              newObj["earlyCare"] = false;
            }

            newObj["allowedToComeAlone"] = bookedHolidayBookings[i].allowedToComeAlone;
            newObj["allowedToGoAlone"] = bookedHolidayBookings[i].allowedToGoAlone;
            newObj["authorizedToCollect"] = bookedHolidayBookings[i].authorizedToCollect;

            newObj["generalsRemarks"] = bookedHolidayBookings[i].remarks;

            /* if (this.selectedHolidayProgramInfo?.addonPrices.find((i) => i.title == "Frühbetreuung")) {
                     if (bookedHolidayBookings[i].selectedExtras.find((i) => i == "Frühbetreuung")) {
                        newObj["earlyCare"] = true
                     } else {
                        newObj["earlyCare"] = false
                     }
                  } else {
                     newObj["earlyCare"] = null
                  } */

            customers.push(newObj);
          }
        }

        customers.sort(function (a, b) {
          let nameA = a.childLastName.toLowerCase();
          let nameB = b.childLastName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return customers;
      }
    },

    sortedBookedHolidayBookingsByGroupsAndChildLastName(): object | null | undefined {
      var bookings: any = this.sortedBookedHolidayBookingsByChildLastName;

      if (bookings) {
        var groupedBookings: { [index: string]: object[] } = {};

        for (let booking of bookings) {
          let group = booking.holidayBookingGroup;

          if (group === "") {
            group = "Nicht_zugeordnet";
          }

          if (!groupedBookings.hasOwnProperty(group)) {
            groupedBookings[group] = [];
          }
          groupedBookings[group].push(booking);
        }

        return groupedBookings;
      }
    },
  },
});
